/**
 * Exact-match prohibited usernames (trust & safety).
 * Expand via code review; do not use naive substring matching (false positives).
 */

const EXPLOITATION_USERNAMES = [
  'childporn',
  'child_porn',
  'childsex',
  'child_sex',
  'lolita',
  'preteen',
  'underage',
  'pedophile',
  'paedophile',
  'pedophilia',
  'rape',
  'rapist',
  'incest',
] as const;

const SCAM_USERNAMES = [
  'giveaway',
  'free_crypto',
  'freecrypto',
  'airdrop',
  'double_your',
  'doubleyour',
  'investment_scheme',
  'investmentscheme',
  'ponzi',
  'pyramid',
  'get_rich',
  'getrich',
  'crypto_scam',
  'cryptoscam',
] as const;

const VIOLENCE_USERNAMES = [
  'kill_yourself',
  'killyourself',
  'kys',
  'gore',
  'beheading',
  'schoolshooter',
  'school_shooter',
] as const;

/** Curated exact-match hate / slur handles. Owned by trust & safety. */
const HATE_SLUR_USERNAMES = [
  'nigger',
  'nigga',
  'faggot',
  'fag',
  'tranny',
  'retard',
  'retarded',
  'kike',
  'spic',
  'chink',
  'gook',
  'wetback',
  'beaner',
  'dyke',
  'homo',
  'nazi',
  'hitler',
  'kkk',
  'whitepower',
  'white_power',
  'heilhitler',
  'heil_hitler',
] as const;

const SPAM_USERNAMES = [
  'onlyfans_promo',
  'onlyfanspromo',
  'spam',
  'spammer',
  'botfarm',
  'bot_farm',
] as const;

export const UNETHICAL_USERNAMES: ReadonlySet<string> = new Set<string>([
  ...EXPLOITATION_USERNAMES,
  ...SCAM_USERNAMES,
  ...VIOLENCE_USERNAMES,
  ...HATE_SLUR_USERNAMES,
  ...SPAM_USERNAMES,
]);
